<script lang="ts">
  import Lock from "~icons/ph/lock-bold";
  import Warning from "~icons/ph/warning-bold";
  import Caret from "~icons/ph/caret-down";
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../../components/workflow/ContinueButton.svelte";
  import { getWorkflow } from "../../../lib/workflow/workflowLib.svelte";
  import { maska } from "maska/svelte";
  import CloseButton from "../../../components/CloseButton.svelte";

  let {
    clientName,
    jlgMainPhone,
    errors = null,
    allowBack = false
  }: {
    clientName: string;
    jlgMainPhone: string;
    errors?: { [key: string]: string } | null;
    allowBack?: boolean;
  } = $props();

  let bankAccount = $state({
    bankName: "",
    accountNumber: "",
    sortCode: "",
  });

  const workflow = getWorkflow();

  function showAside() {
    workflow.aside("name-matching");
    return () => workflow.aside(null);
  }
</script>

<h2 class="ui-title">Add bank account</h2>

<p>Enter your bank details. We'll check that the name on your bank account matches: <b>{clientName}</b>.</p>

<details class="ui-details">
  <summary><Caret />Not your full legal name?</summary>
  <div class="ui-alert ui-alert-warning">
    <Warning />
    Please call us at {jlgMainPhone} to update your details before continuing.
  </div>
</details>

<fieldset class="ui-fieldset">
  <legend>Bank name</legend>
  <input
    type="text"
    name="bank_account[bank_provider]"
    class="ui-input"
    class:border-error={errors?.bank_provider}
    placeholder="Name of your bank"
    autocomplete="off"
    bind:value={bankAccount.bankName}
    required />
  {#if errors?.bank_provider}<div class="ui-error">{errors.bank_provider}</div>{/if}
</fieldset>

<div class="grid grid-cols-2 gap-4">
  <fieldset class="ui-fieldset">
    <legend>Account number</legend>
    <input
      type="text"
      name="bank_account[account_number]"
      class="ui-input"
      class:border-error={errors?.account_number}
      placeholder="8-digit number"
      autocomplete="off"
      inputmode="numeric"
      pattern={"[0-9]{8}"}
      title="8-digit number"
      bind:value={bankAccount.accountNumber}
      required />
    {#if errors?.account_number}<div class="ui-error">{errors.account_number}</div>{/if}
  </fieldset>

  <fieldset class="ui-fieldset">
    <legend>Sort code</legend>
    <input
      type="text"
      name="bank_account[sort_code]"
      class="ui-input"
      class:border-error={errors?.sort_code}
      placeholder="00-00-00"
      autocomplete="off"
      inputmode="numeric"
      pattern={"[0-9]{2}-?[0-9]{2}-?[0-9]{2}"}
      title="6-digit number"
      use:maska={"##-##-##"}
      bind:value={bankAccount.sortCode}
      required />
    {#if errors?.sort_code}<div class="ui-error">{errors.sort_code}</div>{/if}
  </fieldset>
</div>

<div class="ui-alert ui-alert-info">
  <Lock />
  <p>Your bank details are encrypted and securely stored following banking industry standards.</p>
</div>

<FooterButtons back={allowBack}>
  {#if !allowBack}<CloseButton />{/if}
  <ContinueButton type="submit" label="Verify account" onwait={showAside} />
</FooterButtons>
